{
  "name": "@zambelz/zhc",
  "version": "0.2.10",
  "releaseBuildDate": "20 Aug 2025, 04:27:00",
  "description": "API Management Tools",
  "homepage": "https://github.com/zambelz48/zhc#readme",
  "keywords": [
    "api-tools",
    "api-management",
    "rest-cli"
  ],
  "author": "zambelz48 <nanda.julianda48@gmail.com>",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/zambelz48/zhc.git"
  },
  "bugs": {
    "url": "https://github.com/zambelz48/zhc/issues",
    "email": "nanda.julianda48@gmail.com"
  },
  "main": "dist/index.js",
  "bin": {
    "zhc": "./dist/index.js"
  },
  "scripts": {
    "start": "ts-node ./src/index.ts",
    "build": "tsdown",
    "build:watch": "tsdown --watch",
    "changelog": "./scripts/changelog.sh",
    "tag": "./scripts/tag.sh",
    "release:patch": "pnpm version patch --no-git-tag-version && git add package.json && git commit -m \"chore: bump version to $(node -p 'require(\"./package.json\").version')\" && git push origin main",
    "release:minor": "pnpm version minor --no-git-tag-version && git add package.json && git commit -m \"chore: bump version to $(node -p 'require(\"./package.json\").version')\" && git push origin main",
    "release:major": "pnpm version major --no-git-tag-version && git add package.json && git commit -m \"chore: bump version to $(node -p 'require(\"./package.json\").version')\" && git push origin main",
    "release:push": "pnpm tag && git push origin $(node -p \"require('./package.json').version\")",
    "reinstall": "pnpm build && npm uninstall -g zhc && npm install -g"
  },
  "packageManager": "pnpm@10.13.1",
  "engines": {
    "node": ">=22"
  },
  "dependencies": {
    "chalk": "4.1.2"
  },
  "devDependencies": {
    "@types/node": "^22.5.5",
    "ts-node": "^10.9.2",
    "tsdown": "^0.14.1",
    "typescript": "^5.6.2"
  }
}
